import React, { useEffect, useRef, useState } from "react";
import './Home.css';
import { ProductCard } from "../../components/Cards";
import { Link } from "react-router-dom";
import { getHomeProducts } from "../../configs/productsConfig";
import axios from "axios";
import { serverURL, captchaSiteKey } from "../../configs/auth";
import ReCAPTCHA from "react-google-recaptcha";

import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import toast from "react-hot-toast";




function Home() {
  
  const [homeProducts, setHomeProducts] = useState({});
  const reCaptchaRef = useRef();
  const [wish, setWish] = useState({ name: '', email: '', message: '', dataHandling: false });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getHomeProducts();
        setHomeProducts(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const sendIdea = async () => {
  if (!wish.dataHandling) {
    toast.error('Az adatkezelési tájékoztató elfogadása kötelező.');
    return;
  }

  try {
    const token = await reCaptchaRef.current.executeAsync();

    const res = await axios.post(
      `${serverURL}/api/home/sendwish`,
      { wish, captcha: token }
    );

    if (res.status === 200) {
      toast.success('Kívánságod sikeresen rögzítettük.');
      setWish({ name: '', email: '', message: '', dataHandling: false });
    }
  } catch (err) {
    console.error(err);
    toast.error('Kívánságod rögzítése sikertelen.');
  } finally {
    reCaptchaRef.current.reset();
  }
};


  const heroCarousel = [
    <img src="/home3.webp" alt="header img" className="carousel-image" />,
    <img src="/home2.webp" alt="header img" className="carousel-image" />,
    <img src="/home1.webp" alt="header img" className="carousel-image" />,
    <img src="/home4.webp" alt="header img" className="carousel-image" />,
    <img src="/home5.webp" alt="header img" className="carousel-image" />,
  ];

  const feedbackCarousel = [
    <div className="bg-white px-2">
      <img className="img-fluid" alt="feedback img" loading="lazy" src='/v1.webp' />
    </div>,
    <div className="bg-white px-2">
      <img className="img-fluid" alt="feedback img" loading="lazy" src='/v2.webp' />
    </div>,
    <div className="bg-white px-2">
      <img className="img-fluid" alt="feedback img" loading="lazy" src='/v3.webp' />
    </div>,
    <div className="bg-white px-2">
      <img className="img-fluid" alt="feedback img" loading="lazy" src='/v4.webp' />
    </div>,
    <div className="bg-white px-2">
      <img className="img-fluid" alt="feedback img" loading="lazy" src='/v5.webp' />
    </div>,
    <div className="bg-white px-2">
      <img className="img-fluid" alt="feedback img" loading="lazy" src='/v6.webp' />
    </div>,
  ];

 const productsCarousel = homeProducts.highlightedProducts
    ? homeProducts.highlightedProducts.map((highlightedProduct) => (
        // A p-3 adja a térközt a kártyák között, a h-100 pedig biztosítja a magasságot
        <div className="h-100 p-3">
            <ProductCard
                key={highlightedProduct.product_id}
                tableName={highlightedProduct.table_name}
                product={highlightedProduct}
                page="Home"
            />
        </div>
    ))
    : [];



  return (
    <div className='container-fluid p-0'>

      <div className='container-lg d-flex flex-column flex-md-row justify-content-around align-items-center col-12 py-3'>

        <div className="col-md-6">
          <h1 className='lh-base mb-2 h2-home fs-3 text-center'>Könnyítsd meg kreatív munkád és alkoss egyedi dekorációkat otthonodban!</h1>

          <div className="d-flex flex-row justify-content-between align-items-top">
            <Link className="d-flex flex-column align-items-center justify-content-start text-black text-decoration-none" style={{maxWidth:'110px'}} to="/products/prepared_materials">
              <div className="border border-1 border-black mb-1 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }} >
                <i className="bi bi-box2-heart fs-4"></i>
              </div>
              <h3 className="fs-6 text-center" style={{ fontWeight: '450' }}>Kreatív csomagok</h3>
            </Link>

            <Link className="d-flex flex-column align-items-center justify-content-start text-black text-decoration-none" style={{maxWidth:'110px'}} to="/products/materials">
              <div className="border border-1 border-black mb-1 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }} >
                <i className="bi bi-paint-bucket fs-4"></i>
              </div>
              <h3 className="fs-6 text-center" style={{ fontWeight: '450' }}>Minőségi alapanyagok</h3>
            </Link>


            <Link className="d-flex flex-column align-items-center justify-content-start text-black text-decoration-none" style={{maxWidth:'110px'}} to="/products/finished_products">
              <div className="border border-1 border-black mb-1 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }} >
                <i className="bi bi-flower1 fs-4" style={{ fontWeight: '450' }}></i>
              </div>
              <h3 className="fs-6 text-center" style={{ fontWeight: '450' }}>Egyedi alkotások</h3>
            </Link>


            <Link className="d-flex flex-column align-items-center justify-content-start text-black text-decoration-none" style={{maxWidth:'110px'}} to="/guides">
              <div className="border border-1 border-black mb-1 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }} >
                <i className="bi bi-card-checklist fs-4"></i>
              </div>
              <h3 className="fs-6 text-center my-auto px-2" style={{ fontWeight: '450' }}>Útmutatók</h3>
            </Link>

          </div>
        </div>

        <div className="col-12 col-md-5">
          <AliceCarousel
            mouseTracking
            autoPlay
            autoPlayInterval={4000}
            infinite
            disableDotsControls
            disableButtonsControls
            items={heroCarousel}
          />
        </div>

      </div>

      <div className="bgcolorblue">
        <div className="container-lg border-top py-4 d-flex flex-column justify-content-center align-items-center">
          <h2 className="fs-4 mb-4 text-center">„Boldogsággal készítve, szeretettel ajándékozva!”</h2>
          <h4 className="fs-6 col-12 col-md-9 text-center lh-p">Előre összeállított kézműves csomagokkal, kreatív alapanyagokkal és különleges kézműves termékekkel segítek, hogy az alkotás valódi öröm legyen.</h4>

        </div>
      </div>

     <div className="container-lg border-top px-0 py-4">
        <h2 className="h2-home ps-2 m-0">Népszerű termékek</h2>
        {productsCarousel.length > 0 ? (
            <AliceCarousel
                autoPlay
                autoPlayInterval={3500}
                animationDuration={700}
                infinite
                pauseOnHover
                mouseTracking
                disableButtonsControls
                responsive={{
                    0: { items: 2 },
                    576: { items: 3 },
                    768: { items: 4 },
                }}
                items={productsCarousel}
            />
        ) : (
            <p>Nincs termék</p>
        )}
    </div>


      <div className="bgcolorblue">
        <div className="container-lg border-top py-3">
          <div className="row justify-content-center g-4">

            <div className="col-10 col-lg-3">
              <div className="bg-light border rounded text-center shadow p-3 d-flex flex-column h-100">
                <h4 className="fs-5 mb-2 text-decoration-underline">
                  Alapanyagok
                </h4>

                <p className="my-auto mb-2">
                  Gondosan válogatott, minőségi alapanyagok kreatív hobbi projektekhez és kézműves alkotásokhoz.
                </p>

                <Link className="btn btn-home-primary mt-auto mx-3" to="/products/materials">
                  Megnézem <span className="btn-span">{'>'}</span>
                </Link>
              </div>
            </div>

            <div className="col-10 col-lg-3">
              <div className="border bg-light rounded text-center shadow p-3 d-flex flex-column h-100">
                <h4 className="fs-5 mb-2 text-decoration-underline">
                  Kézműves csomagok
                </h4>

                <p className="my-auto mb-2">
                  Előre összeállított kreatív csomagok, amelyek minden szükséges alapanyagot tartalmaznak.
                </p>

                <Link className="btn btn-home-primary mt-auto mx-3 mx-lg-0" to="/products/prepared_materials">
                  Csináld magad <span className="btn-span">{'>'}</span>
                </Link>
              </div>
            </div>

            <div className="col-10 col-lg-3">
              <div className="border bg-light rounded text-center shadow p-3 d-flex flex-column h-100">
                <h4 className="fs-5 mb-2 text-decoration-underline">
                  Kész termékek
                </h4>

                <p className="my-auto mb-2">
                  Különleges, kézzel készült dekorációk, amelyek azonnal hangulatot visznek az otthonodba.
                </p>

                <Link className="btn btn-home-primary mt-auto mx-3" to="/products/finished_products">
                  Érdekel <span className="btn-span">{'>'}</span>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>



      <div className="container-lg py-3 border-top border-bottom">
        <h2 className="h2-home">Rólam mondták...</h2>
        <AliceCarousel
          autoPlay
          autoPlayInterval={6000}
          infinite
          disableDotsControls
          disableButtonsControls
          autoPlayStrategy="none"
          responsive={{
            0: { items: 1 },       // mobil: 1 kép
            768: { items: 2 },     // tablet és nagyobb: 2 kép
          }}
          items={feedbackCarousel}
        />
      </div>


      <div className='container-fluid d-flex flex-column align-items-center py-3 bgcolorblue'>

        <h3 className='mb-2 h2-home'>Kívánság doboz</h3>
        <p className='text-center lh-base fs-6'>Ha van olyan ötleted, amit nem találtál meg, de szívesen látnál az oldalon. <br /> Jelezd és megpróbálom megvalósítani!</p>

        <div className="d-flex flex-column align-items-center col-12 col-md-10 col-lg-6 shadow rounded p-4 bg-light-subtle">
          {/* Név mező */}
          <label className="fs-6 fw-medium mb-2 w-100">Név</label>
          <input
            type="text"
            className="mb-3 col-12 col-md-11 col-lg-10 rounded input-border p-2 fs-6"
            placeholder="Írd be a neved"
            value={wish.name}
            onChange={(e) => setWish(prevData => ({ ...prevData, name: e.target.value }))}
          />

          {/* Email cím mező */}
          <label className="fs-6 fw-medium mb-2 w-100">Email cím</label>
          <input
            type="email"
            className="mb-3 col-12 col-md-11 col-lg-10 rounded input-border p-2 fs-6"
            placeholder="Írd be az email címed"
            value={wish.email}
            onChange={(e) => setWish(prevData => ({ ...prevData, email: e.target.value }))}
          />

          {/* Kívánság mező */}
          <label className="fs-6 fw-medium mb-2 w-100">Kívánság</label>
          <textarea
            rows="6"
            className="col-12 col-md-11 col-lg-10 rounded input-border p-2 fs-6"
            placeholder="Írd le a kívánságodat"
            maxLength={250}
            value={wish.message}
            onChange={(e) => setWish(prevData => ({ ...prevData, message: e.target.value }))}

          />

          <div className="form-check mt-3">
            <input className="form-check-input"
              type="checkbox"
              checked={wish.dataHandling}
              onChange={(e) =>
                setWish(prevData => ({
                  ...prevData,
                  dataHandling: e.target.checked
                }))
              }
              id="wishData" />
            <label className="form-check-label" htmlFor="wishData">
              Az <a href="/Adatvedelmi.pdf" target="_blank" rel="noopener noreferrer">Adatkezelési tájékoztatót</a> elolvastam és elfogadom.
            </label>
          </div>

          <ReCAPTCHA
            sitekey={captchaSiteKey}
            size="invisible"
            ref={reCaptchaRef}
          />
          
          <button className="btn btn-home-primary mt-2 w-50 w-md-25" onClick={() => sendIdea(wish)}>
            Küldés
          </button>
        </div>
      </div>

    </div>
  );
}

export default Home;


/**
   <div className="bgcolorblue">
        <div className="container-lg border-top py-4">
          <h2 className="h2-home">Ne hagyd ki a különleges ajánlatainkat!</h2>

          <div className="d-flex justify-content-between align-items-center">
            
            <button
              className="btn btn-scroll d-none d-md-inline"
              onClick={() => saleScrollContainer.current.scrollBy({ left: -200, behavior: 'smooth' })}
            >
              <i className="bi bi-caret-left"></i>
            </button>

           
            <div className="scrollingdiv w-100 py-2 d-flex gap-3 overflow-x-auto" ref={saleScrollContainer}>
              {homeProducts.onSaleProducts ? (
                homeProducts.onSaleProducts.map((onSaleProduct) => (
                  <ProductCard
                    key={onSaleProduct.product_id}
                    tableName={onSaleProduct.table_name}
                    product={onSaleProduct}
                    page={'Home'}
                  />
                ))
              ) : (
                <p>Nincs termék</p>
              )}
            </div>

            <button
              className="btn btn-scroll d-none d-md-inline"
              onClick={() => saleScrollContainer.current.scrollBy({ left: 200, behavior: 'smooth' })}
            >
              <i className="bi bi-caret-right"></i>
            </button>
          </div>
        </div>
      </div>


      <div className='d-flex flex-column flex-lg-row align-items-center justify-content-between border-top container-lg px-3'>

        <img src='/diy.webp' alt='diyflower' className='mt-3 mb-lg-3 col-8 col-md-6 col-lg-5 rounded' />

        <div className='col-11 col-lg-6 py-3'>
          <h2 className='lh-base fs-2 mb-3 text-center h2-home'>Csatlakozz hozzánk és hozd létre saját művészi alkotásaidat, amelyek tükrözik egyedi stílusodat, személyiségedet.</h2>
          <p className='text-center fs-6 fw-normal lh-p'>
            Fedezd fel <span className='fw-semibold'>lépésről lépésre útmutatóinkat</span>, különböző kreatív technikákat és magas minőségű alapanyagainkat, hogy <span className='fw-semibold'>te is részese lehess a kézműves alkotás örömének</span>.
          </p>
          <div className='col-12 d-flex flex-row justify-content-center'>
            <Link className='btn btn-home-primary px-4' to="/products/prepared_materials">Megnézem <span className='btn-span'>{'>'}</span></Link>
          </div>
        </div>

      </div>


        <div className="d-flex flex-md-row flex-column justify-content-center align-items-center">

          <div className='d-flex flex-column justify-content-center align-items-center'>

            <p className='text-justify fs-6 fw-normal lh-p mx-2 mx-md-3 mb-0'>
              A webshop célja, hogy <span className='fw-semibold'>megkönnyítse a kreatív hobbi szerelmeseinek munkáját</span>, miközben különleges alkotások létrehozását támogatja. Válogass <span className='fw-semibold'>előre összeállított alapanyagok</span> és <span className='fw-semibold'>kész kézműves termékek</span> széles választékából.
            </p>

            <div className='d-flex flex-row col-12 justify-content-around my-2'>
              <Link className='btn btn-home-primary rounded px-lg-4' to="/products/materials">Alapanyagok</Link>
              <Link className='btn btn-home-primary rounded px-lg-4' to="/products/prepared_materials">Csináld magad!</Link>
              <Link className='btn btn-home-primary rounded px-lg-4' to="/products/finished_products">Kész termékek</Link>
            </div>


          </div>

          
        </div>




      
          <button
            className="btn btn-scroll d-none d-md-inline"
            onClick={() => srcollContainer.current.scrollBy({ left: -200, behavior: 'smooth' })}
          >
            <i className="bi bi-caret-left"></i>
          </button>

         
          <div className="scrollingdiv w-100 py-2 d-flex gap-3 overflow-x-auto" ref={srcollContainer}>
            {homeProducts.highlightedProducts ? (
              homeProducts.highlightedProducts.map((highlightedProduct) => (
                <ProductCard
                  key={highlightedProduct.product_id}
                  tableName={highlightedProduct.table_name}
                  product={highlightedProduct}
                  page={'Home'}
                />
              ))
            ) : (
              <p>Nincs termék</p>
            )}
          </div>

       
          <button
            className="btn btn-scroll d-none d-md-inline"
            onClick={() => srcollContainer.current.scrollBy({ left: 200, behavior: 'smooth' })}
          >
            <i className="bi bi-caret-right"></i>
          </button>
 */